/**
 * @graphql cc
 */
import gql from 'graphql-tag';
import {
	// eslint-disable-next-line graphql-relay-compat/no-import-apollo-functions -- Read http://go/cfe-no-import-apollo-functions
	useQuery,
} from '@apollo/react-hooks';
import React from 'react';

import { ErrorDisplay } from '@confluence/error-boundary/entry-points/ErrorDisplay';

import type {
	ArchiveProcessSuccessQuery as ArchiveProcessSuccessQuery$data,
	ArchiveProcessSuccessQueryVariables as ArchiveProcessSuccessQuery$variables,
} from './__types__/ArchiveProcessSuccessQuery';

const TOOLS_MENU_LOCATION = 'system.content.action';

type ArchiveProcessSuccessProps = {
	contentId: string;
	processedPageIds: string[];
};

export function ArchiveProcessSuccess({ contentId, processedPageIds }: ArchiveProcessSuccessProps) {
	const { error } = useQuery<ArchiveProcessSuccessQuery$data, ArchiveProcessSuccessQuery$variables>(
		gql`
			query ArchiveProcessSuccessQuery(
				$contentId: ID!
				$processedPageIds: [ID]!
				$webItemLocation: String!
				$navigationType: String
			) {
				content(
					ids: $processedPageIds
					status: ["archived", "current"]
					navigationType: $navigationType
				) {
					nodes {
						id
						type
						operations {
							operation
							targetType
						}
						status
						type
						ancestors {
							id
							type
							title
							status
						}
					}
				}
				singleContent(id: $contentId) {
					id
					children {
						count
						nodes {
							id
							status
						}
					}
					hasVisibleChildPages
				}
				webItemSections(location: $webItemLocation, contentId: $contentId) {
					id
					label
					styleClass
					cacheKey
					items {
						accessKey
						completeKey
						hasCondition
						id
						icon {
							path
						}
						params {
							key
							value
						}
						label
						moduleKey
						section
						styleClass
						tooltip
						url
						urlWithoutContextPath
						weight
					}
				}
			}
		`,
		{
			errorPolicy: 'all',
			fetchPolicy: 'network-only',
			variables: {
				contentId,
				processedPageIds,
				webItemLocation: TOOLS_MENU_LOCATION,
				navigationType: 'contentTree',
			},
		},
	);

	return error ? <ErrorDisplay error={error} /> : null;
}
